import create from 'zustand';

import { LoginConfigStore } from '../../../types/loginConfig';

export const useLoginConfigStore = create<LoginConfigStore>((set) => ({
	carbonioDomainName: '',
	isOtpWizardActive: false,
	loginLogo: undefined,
	/* 'initial' until the credentials form mounts, 'none' once another form replaces it */
	loginStep: 'initial',
	loginUsername: '',
	loginErrorAt: 0,
	loginWelcome: false,
	setDomainName: (carbonioDomainName: string): void => set({ carbonioDomainName })
}));
